function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCogActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.973,
    height: 21.973,
    viewBox: "0 0 21.973 21.973",
    id: "svg825",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M487.836,502.773l-2.357-.429a8.622,8.622,0,0,0-.343-.819l1.366-1.982a.516.516,0,0,0-.063-.64l-2.824-2.824a.516.516,0,0,0-.632-.055l-1.974,1.358a8.689,8.689,0,0,0-.827-.335l-.429-2.364a.515.515,0,0,0-.492-.406h-3.995a.532.532,0,0,0-.492.406l-.429,2.364a8.689,8.689,0,0,0-.827.335l-1.982-1.358a.516.516,0,0,0-.632.055l-2.824,2.824a.517.517,0,0,0-.063.64l1.365,1.974a8.574,8.574,0,0,0-.343.827l-2.349.429a.516.516,0,0,0-.414.491v4a.516.516,0,0,0,.414.492l2.357.429a8.611,8.611,0,0,0,.351.827l-1.373,1.966a.516.516,0,0,0,.055.64l2.824,2.824a.516.516,0,0,0,.632.055l1.974-1.358a8.762,8.762,0,0,0,.835.343l.429,2.357a.516.516,0,0,0,.492.414h3.995a.516.516,0,0,0,.492-.414l.429-2.357a8.8,8.8,0,0,0,.827-.343l1.974,1.358a.516.516,0,0,0,.632-.055l2.824-2.824a.516.516,0,0,0,.063-.64L485.136,509a8.7,8.7,0,0,0,.335-.811l2.372-.437a.515.515,0,0,0,.406-.492v-4A.516.516,0,0,0,487.836,502.773Zm-10.573,7.733a5.244,5.244,0,1,1,5.244-5.244A5.251,5.251,0,0,1,477.263,510.506Z",
    transform: "translate(-466.276 -494.276)",
    fill: "#c8cacc",
    style: {
      fill: "#333333"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCogActive);
export default __webpack_public_path__ + "static/media/cog_active.1097b838b7646fa72fa7aa62a26b7e96.svg";
export { ForwardRef as ReactComponent };